import {useQuery} from "@tanstack/react-query";
import {getData} from "../getters/getData.js";


export const useWizardMapping = (url, name, enabled = true) => {
    return useQuery({
        queryKey: [`wizard_mapping__${name}`],
        queryFn: () => getData(url),
        enabled: enabled
    })
}